<template>
  <div class="pagination">
    <el-pagination
      :page-sizes="[10]"
      :page-size="size"
      :current-page.sync="curpage"
      @size-change="sizechange"
      @current-change="changePage"
      layout=" prev, pager, next, total"
      :total="count"
      v-if="limitrue == false"
    >
    </el-pagination>
    <el-pagination
      :page-size="6"
      :current-page.sync="page"
      @size-change="sizechange"
      @current-change="changePage"
      layout=" prev, pager, next, total"
      :total="count"
      hide-on-single-page="true"
      v-else
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "page",
  data() {
    return {
      page: 1,
      size: 10,
    };
  },
  props: {
    count: {
      type: Number,
      default: "",
    },
    limitrue: {
      type: Boolean,
      default: false,
    },
    curpage: {
      type: Number,
      default: "",
    },
  },
  methods: {
    changePage(e) {
      // console.log(2222)
      this.page = e;
      this.curpage = e;
      this.$emit("pagenation", this.size, e);
    },
    sizechange(e) {
      this.limit = e;
      // console.log('555')
      this.$emit("pagenation", e, this.page);
    },
  },
};
</script>
<style>
.pagination {
  margin-top: 20px;
  float: right;
}
.pagination .el-pager li {
  border: 1px solid #444;
  border-radius: 4px;
  margin-left: 8px;
  color: #444;
}
.pagination .btn-next {
  margin-left: 8px;
}
.pagination .el-pagination__total {
  float: right;
  margin-left: 10px;
}
.pagination .btn-prev,
.pagination .btn-next {
  border: 1px solid #444;
  border-radius: 4px;
  padding: 0;
  color: #444;
}
.pagination .el-pager .active,
.el-pager li:hover {
  border-color: #55acef;
  color: #55acef;
}
.pagination .el-pager li.active + li:hover {
  border-left: 1px solid #55acef;
}
.pagination .el-pager li.active + li {
  border-left: 1px solid #444;
}
.pagination .el-pagination__sizes {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/page.vue